import "./index.css";

import Image from "next/image";
import Link from "next/link";
import React from "react";
import { RemoveScroll } from "react-remove-scroll";

import { NavigatioCategory, NavigatioImage } from "@/graphql/types/graphql";
import { Search_Type } from "@/graphql/types/graphql";
import { encodeURL } from "@/utils/index";

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  show: boolean;
  categories: NavigatioCategory[];
  images: NavigatioImage[];
  onClose: () => void;
}

const Container: React.FC<ContainerProps> = ({
  show,
  children,
  categories,
  images,
  onClose,
  ...rest
}) => {
  return (
    <>
      <RemoveScroll enabled={show} removeScrollBar={false}>
        <div
          className="dropdown-container"
          style={{ display: show ? "block" : "none" }}
          {...rest}
        >
          <div className="dropdown-fade">
            <div
              style={{ width: "100vw", height: "100px", background: "#fff" }}
            ></div>
          </div>
          <div
            className="content"
            onMouseLeave={() => {
              if (onClose) onClose();
            }}
          >
            <div className="content-inner section-container">
              <div className="left">
                {categories.map((category) => (
                  <div className="column" key={category.title}>
                    <div className="column-title">{category.title}</div>
                    {category.items.map((item) => (
                      <Link
                        key={item.searchQuery}
                        href={`/edits/${encodeURL(item.searchQuery)}?type=${
                          Search_Type.Item
                        }`}
                        className="dropdown-link"
                      >
                        {item.text}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
              <div className="right">
                {images.map((image) => (
                  <Link
                    href={`/edits/${encodeURL(image.query)}`}
                    key={image.text}
                    style={{ width: "50%" }}
                  >
                    <div className="item">
                      <Image
                        src={image.image}
                        alt={image.text}
                        loading="lazy"
                        width={700}
                        height={1000}
                        style={{
                          marginBottom: 10,
                          aspectRatio: 0.7,
                          objectFit: "cover",
                        }}
                      />
                      <div className="item-text">{image.text}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          {children}
        </div>
      </RemoveScroll>
      <style jsx>{`
        .dropdown-container {
          width: 100vw;
          height: 100vh;
          position: fixed;
          z-index: 100;
          left: 0;
          transform: translateY(20px);
        }
        .dropdown-fade {
          width: 100%;
          height: 100%;
          z-index: 2;
          background: rgba(0, 0, 0, 0.4);
          position: fixed;
        }
        .content {
          position: relative;
          z-index: 101;
          background: #fff;
          display: flex;
          justify-content: center;

          .content-inner {
            padding: 32px 72px 72px;
            display: flex;
            justify-content: space-between;

            .left {
              display: flex;
              color: #666;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;

              .column {
                width: 200px;
                display: flex;
                flex-direction: column;
                margin-right: 42px;
                text-align: left;

                .column-title {
                  color: #191919;
                  margin-bottom: 18px;
                }
              }
            }

            .right {
              display: flex;
              gap: 24px;

              .item {
                flex: auto;
                color: #191919;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 160%; /* 22.4px */

                width: 100%;
                max-width: 258px;

                .item-text {
                  text-align: left;
                }
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default Container;
